import React from "react";
import Banner from "../Components/Banner";

const policies = [
  {
    title: "1. Introduction",
    text: "These Terms and Conditions govern the use of services provided by HNH Soft Tech Solutions Pvt Ltd. By accessing our website or engaging our services, you agree to comply with these terms.",
  },
  {
    title: "2. Services",
    text: "HNH Soft Tech Solutions Pvt Ltd provides digital services including web development, mobile application development, UI/UX design, and digital marketing solutions. All services are delivered digitally according to the agreed project scope.",
  },
  {
    title: "3. Scope of Work",
    text: "The scope of each project will be defined in a written agreement, proposal, or email confirmation. Clients agree to provide all required materials, feedback, and approvals necessary for project completion.",
  },
  {
    title: "4. Pricing and Payment",
    text: "Service pricing varies depending on project complexity and requirements. Payment terms, including milestone payments or hourly billing, will be agreed upon before work begins. All payments are conducted in PKR and must be completed within the specified invoice period.",
  },
  {
    title: "5. Project Delivery",
    text: "All services and deliverables are provided digitally via secure file transfer, email, repository access, or server deployment. Delivery timelines are agreed upon before the start of each project.",
  },
  {
    title: "6. Refund and Cancellation",
    text: "Due to the custom nature of software development services, refunds are generally not available once work has started or deliverables have been shared. Cancellation requests may be considered before the start of a milestone.",
  },
  {
    title: "7. Confidentiality",
    text: "Both parties agree to maintain confidentiality of all proprietary information, business data, and project materials shared during the course of the project.",
  },
  {
    title: "8. Intellectual Property",
    text: "Upon full payment of the project invoice, the client receives ownership rights to the final deliverables unless otherwise specified. HNH Soft Tech Solutions Pvt Ltd reserves the right to showcase completed work in its portfolio.",
  },
  {
    title: "9. Limitation of Liability",
    text: "HNH Soft Tech Solutions Pvt Ltd shall not be liable for indirect, incidental, or consequential damages resulting from the use of our services or deliverables.",
  },
  {
    title: "10. Termination",
    text: "Either party may terminate a project with written notice. Any work completed up to the termination date must be compensated according to the agreed payment terms.",
  },
  {
    title: "11. Changes to Terms",
    text: "HNH Soft Tech Solutions Pvt Ltd reserves the right to update or modify these Terms and Conditions at any time. Updated versions will be published on this page.",
  },
  {
    title: "12. Contact Information",
    text: `For any questions regarding these Terms and Conditions, please contact us at info@hnhsofttechsolutions.com or visit our office at Office #402 4th Floor plot# 172-M, Block-2 P.E.C.H.S. Employees Co-operate
Bahadurabad.`,
  },
  {
    title: "13. Delivery Policy",
    text: "HNH Soft Tech Solutions Pvt Ltd delivers all services digitally through secure channels such as email, cloud storage, Git repositories, or direct server deployment. Project timelines are communicated and agreed upon before the commencement of work. While we strive to meet all deadlines, delivery schedules may be adjusted due to project revisions, delays in client feedback, or unforeseen technical challenges. Clients will be promptly informed of any changes in delivery timelines. Access to Git repositories or final deliverables will be provided after the completion of agreed payment milestones.",
  }
];

const TermsCondition = () => {
  return (
    <>
      <Banner heading="Terms and Conditions" text="Terms and Conditions" />

      <section className="py-20 px-4 bg-gray-50 font-sans">
        <div className="px-20">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#025383] mb-4">Terms & Conditions</h2>
            <p className="text-gray-800 text-center text-xl">Please read our terms and conditions governing the use of our services.</p>
          </div>

          <div className="space-y-6">
            {policies.map((item, index) => (
              <div
                key={index}
                className="bg-white border-l-[6px] border-[#025383] rounded-2xl p-6 sm:p-8 shadow-[0_4px_20px_rgba(0,0,0,0.04)] hover:shadow-[0_4px_25px_rgba(2,83,131,0.12)] transition-all duration-300"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#025383]/10 flex items-center justify-center text-[#025383] text-xl font-bold">
                    {index + 1}
                  </div>
                  <h3 className="text-[#025383] text-2xl font-bold">
                    {item.title.replace(/^\d+\.\s*/, '')}
                  </h3>
                </div>
                <p className="text-gray-700 leading-relaxed text-[17px] sm:pl-16 whitespace-pre-line">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsCondition;